<app-loading-spinner [active]="deletingLoading"></app-loading-spinner>

<div class="row">
    <div class="col-12" *ngIf="documentsLoading">
        <ngx-skeleton-loader [theme]="{
                    height: '244px',
                    margin:'0 0 24px'
                }">
        </ngx-skeleton-loader>
    </div>

    <div class="col-12" *ngIf="!documentsLoading">
        <div class="dash-details-card">
            <div class="dash-details-card-header justify-content-between"
                style="margin-top: 32px;">
                <div class="d-flex align-items-center">
                    <app-button [inverted]="true" class="mr-2"
                        (onClick)="handleGetDocuments(true)"
                        [disabled]="tableLoading || documentsLoading">
                        <svg-icon src="assets/images/icon-renew.svg"
                            class="mr-2"></svg-icon>
                        Atualizar
                    </app-button>
                </div>
                <div class="d-flex align-items-center"
                    style="gap: 12px; margin-top: 24px;">
                    <div class="dropdown-wrapper" *ngIf="isMasterUser()">
                        <span class="dropdown-label">Departamento
                            relacionado</span>
                        <div class="dropdown-container" #departmentDropdown
                            style="position: relative;">
                            <button class="dropdown-container-content"
                                type="button"
                                [class.active]="showDepartmentDropdown"
                                (click)="toggleDepartmentDropdown()">
                                <span>{{getSelectedDepartmentLabel()}}</span>
                                <svg-icon
                                    src="assets/images/icon-down.svg"></svg-icon>
                            </button>
                            <div class="dropdown"
                                *ngIf="showDepartmentDropdown">
                                <button
                                    *ngFor="let option of filterDepartmentOptions"
                                    type="button" class="dropdown-button"
                                    [class.active]="selectedDepartmentFilter === option.value"
                                    (click)="selectDepartmentFilter(option)">
                                    {{option.label}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <app-button (click)="toggleAttachmentModal()">
                        Anexar documento
                    </app-button>
                </div>
            </div>
            <app-empty-content [isVisible]="!hasDocuments() && !tableLoading"
                title="Nenhum documento encontrado"
                description="Não foi encontrado nenhum documento interno nesse cadastro"
                icon="/assets/images/forgot-password-icon2.png">
            </app-empty-content>

            <div class="table-scroll-container"
                *ngIf="hasDocuments() || tableLoading"
                style="margin-top: 56px;">
                <!-- Skeleton Loading da Tabela -->
                <table *ngIf="tableLoading" class="skeleton-table">
                    <tbody>
                        <tr *ngFor="let i of [1, 2, 3]"
                            class="alternative-header">
                            <!-- Coluna Arquivo -->
                            <td style="max-width: 500px;">
                                <div class="dash-card-item"
                                    style="display: flex; align-items: center; gap: 6px;">
                                    <div>
                                        <ngx-skeleton-loader appearance="circle"
                                            [theme]="{
                                                height: '40px',
                                                width: '40px',
                                                marginBottom: '0'
                                            }">
                                        </ngx-skeleton-loader>
                                    </div>
                                    <app-spacer [right]="16"></app-spacer>
                                    <div class="dash-card-item-content">
                                        <ngx-skeleton-loader [theme]="{
                                                height: '16px',
                                                width: '200px',
                                                marginBottom: '0'
                                            }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </div>
                            </td>
                            <!-- Coluna Enviado por -->
                            <td>
                                <div class="dash-card-item">
                                    <div class="dash-card-item-content">
                                        <ngx-skeleton-loader [theme]="{
                                                height: '16px',
                                                width: '150px',
                                                marginBottom: '0'
                                            }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </div>
                            </td>
                            <!-- Coluna Enviado em -->
                            <td>
                                <div class="dash-card-item">
                                    <div class="dash-card-item-content">
                                        <ngx-skeleton-loader [theme]="{
                                                height: '16px',
                                                width: '120px',
                                                marginBottom: '4px'
                                            }">
                                        </ngx-skeleton-loader>
                                        <ngx-skeleton-loader [theme]="{
                                                height: '14px',
                                                width: '80px',
                                                marginBottom: '0'
                                            }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </div>
                            </td>
                            <!-- Coluna Departamento (apenas para master) -->
                            <td *ngIf="isMasterUser()">
                                <div class="dash-card-item">
                                    <div class="dash-card-item-content">
                                        <ngx-skeleton-loader [theme]="{
                                                height: '16px',
                                                width: '140px',
                                                marginBottom: '0'
                                            }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </div>
                            </td>
                            <!-- Coluna Ações -->
                            <td>
                                <div class="d-flex align-items-center justify-content-end"
                                    style="gap: 12px;">
                                    <ngx-skeleton-loader [theme]="{
                                            height: '32px',
                                            width: '32px',
                                            borderRadius: '6px',
                                            marginBottom: '0'
                                        }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                            height: '32px',
                                            width: '32px',
                                            borderRadius: '6px',
                                            marginBottom: '0'
                                        }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- Tabela com Dados -->
                <table *ngIf="!tableLoading">
                    <thead>
                        <tr class="alternative-header">
                            <th>Arquivo</th>
                            <th>Enviado por</th>
                            <th>Enviado em</th>
                            <th *ngIf="isMasterUser()">Departamento Relacionado
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="alternative-header"
                            *ngFor="let item of documents">
                            <td style="max-width: 500px;">
                                <div class="dash-card-item"
                                    style="display: flex; align-items: center; gap: 6px;">
                                    <div>
                                        <span>
                                            <img
                                                src="{{renderIcon(item.file)}}" />
                                        </span>
                                    </div>

                                    <app-spacer [right]="16"></app-spacer>

                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{item.description || item.name ||
                                            item.label || 'Documento Interno'}}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="dash-card-item">
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{getSenderName(item)}}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="dash-card-item">
                                    <div class="dash-card-item-content">
                                        <div class="dash-card-item-content-title"
                                            *ngIf="formateDate(item.created_at).day">
                                            {{formateDate(item.created_at).day}}
                                        </div>
                                        <div class="dash-card-item-content-subtitle"
                                            *ngIf="formateDate(item.created_at).hours">
                                            às
                                            {{formateDate(item.created_at).hours}}
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td *ngIf="isMasterUser()">
                                <div class="dash-card-item">
                                    <div class="dash-card-item-content">
                                        <div
                                            class="dash-card-item-content-title">
                                            {{item.department_name || '--'}}
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div class="d-flex align-items-center justify-content-end"
                                    style="gap: 12px;">
                                    <app-tooltip text="Visualizar">
                                        <button class="button datasheet-button"
                                            (click)="openDocument(item)"
                                            style="font-size: 0.85rem;">
                                            <svg-icon
                                                src="assets/images/icon-eye.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                    <app-tooltip
                                        [text]="canDeleteDocument(item) ? 'Excluir' : 'Não é possível remover arquivos enviados por outra pessoa'"
                                        [position]="canDeleteDocument(item) ? 'top' : 'left'">
                                        <button class="button datasheet-button"
                                            (click)="deleteDocument(item)"
                                            [disabled]="deletingDocumentId === item.id || !canDeleteDocument(item)"
                                            [class.disabled]="!canDeleteDocument(item)"
                                            style="font-size: 0.85rem;">
                                            <svg-icon
                                                src="assets/images/icon-trash.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <app-spacer [bottom]="28"></app-spacer>
                </table>
            </div>
        </div>
    </div>
</div>

<app-side-modal [active]="showAttachmentModal" title="Anexar documento"
    (onClose)="toggleAttachmentModal()" paddingBottom="30">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <app-input type="text" [group]="documentNameForm"
                    controlName="documentName" label="Nome do documento"
                    placeholder="Digite o nome do documento"
                    (onChange)="onDocumentNameChange($event)">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row" *ngIf="isMasterUser()">
            <div class="col-12">
                <app-select [items]="departmentOptions" [group]="departmentForm"
                    controlName="department" label="Departamento Relacionado"
                    placeholder="Selecione o departamento">
                </app-select>
                <app-spacer [bottom]="12"></app-spacer>
                <p
                    style="font-size: var(--font-xs); color: var(--light); margin: 0; line-height: 1.5;">
                    O documento enviado será visto por todos usuários master e
                    todos relacionados à respectiva área escolhida.
                </p>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <app-dropzone (filesChange)="setFiles($event)"
                    [clearAttachments]="clearAttachments">
                </app-dropzone>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6 d-flex align-items-center">
                <app-button (onClick)="toggleAttachmentModal()"
                    class="add-button" [outline]="true">
                    Cancelar
                </app-button>
            </div>

            <div
                class="col-12 col-lg-6 d-flex align-items-center justify-content-end">
                <app-button (onClick)="uploadAttachment()"
                    [disabled]="getAttachmentDisabled() || uploadLoading"
                    [loading]="uploadLoading" class="add-button">
                    Anexar
                </app-button>
            </div>
        </div>
    </div>
</app-side-modal>

<app-carbon-warning-modal [active]="showDeleteModal"
    [title]="getDeleteModalTitle()" [message]="getDeleteModalMessage()"
    [confirmText]="getDeleteConfirmText()" [cancelText]="getDeleteCancelText()"
    [confirmAction]="confirmDeleteDocument.bind(this)"
    [cancelAction]="closeDeleteModal.bind(this)" (onClose)="closeDeleteModal()">
</app-carbon-warning-modal>

<app-document-visualizer-modal [active]="showDocumentModal"
    [file]="selectedDocument" (onClose)="closeDocumentModal()">
</app-document-visualizer-modal>